export const FEATURE_LIMIT_BADGE = 'FeatureLimitBadge';
export const STARTER = 'starter';
export const PRO = 'pro';